(function () {
  const selectors = {
    container: '[data-cart-page-consent]',
    form: '#cart',
    checkoutButton: '#checkout',
    checkbox: '[data-cart-page-consent-checkbox]',
    error: '[data-cart-page-consent-error]',
    expressButtons: '.cart__dynamic-checkout-buttons.additional-checkout-buttons'
  };

  let consentReady = false;
  let consentSavePending = false;

  function getElements() {
    const container = document.querySelector(selectors.container);

    return {
      container,
      form: document.querySelector(selectors.form),
      checkoutButton: document.querySelector(selectors.checkoutButton),
      checkbox: container ? container.querySelector(selectors.checkbox) : null,
      error: container ? container.querySelector(selectors.error) : null,
      expressButtons: Array.from(document.querySelectorAll(selectors.expressButtons))
    };
  }

  function getConsentVersion() {
    const { container } = getElements();
    return container ? container.dataset.cartPageConsentVersion : 'digital-access-waiver-test-2026-06-11';
  }

  function setError(message) {
    const { error } = getElements();
    if (!error) return;

    error.textContent = message || 'Please confirm immediate digital access before checkout.';
    error.hidden = !message;
  }

  function setCheckoutState(enabled, busy) {
    const { checkoutButton } = getElements();
    if (!checkoutButton) return;

    checkoutButton.disabled = !enabled;

    if (busy) {
      checkoutButton.setAttribute('aria-busy', 'true');
    } else {
      checkoutButton.removeAttribute('aria-busy');
    }
  }

  function setExpressState(enabled) {
    const { expressButtons } = getElements();

    expressButtons.forEach((wrapper) => {
      wrapper.classList.add('cart-page-consent__express');
      wrapper.classList.toggle('cart-page-consent__express--ready', enabled);
    });
  }

  function showConsentError() {
    const { checkbox } = getElements();

    setError('Please confirm immediate digital access before checkout.');

    if (checkbox) {
      checkbox.focus();
    }
  }

  function setupExpressOverlays() {
    const { expressButtons } = getElements();

    expressButtons.forEach((wrapper) => {
      if (wrapper.querySelector('.cart-page-consent__express-overlay')) return;

      const overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = 'cart-page-consent__express-overlay';
      overlay.setAttribute('aria-label', 'Confirm immediate digital access before using express checkout.');
      overlay.addEventListener('click', showConsentError);

      wrapper.classList.add('cart-page-consent__express');
      wrapper.appendChild(overlay);
    });

    setExpressState(consentReady && !consentSavePending);
  }

  function setReadyState(ready, busy) {
    consentReady = ready;
    consentSavePending = busy;
    setCheckoutState(ready && !busy, busy);
    setExpressState(ready && !busy);
  }

  function saveConsent() {
    const acceptedAt = new Date().toISOString();
    const body = JSON.stringify({
      attributes: {
        digital_access_waiver_accepted: 'true',
        digital_access_waiver_accepted_at: acceptedAt,
        digital_access_waiver_source: 'cart_page',
        digital_access_waiver_version: getConsentVersion()
      }
    });

    setReadyState(false, true);
    setError('');

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) throw new Error('Consent could not be saved.');
        return response.json();
      })
      .then(() => {
        setReadyState(true, false);
      })
      .catch(() => {
        const { checkbox } = getElements();

        if (checkbox) {
          checkbox.checked = false;
        }

        setReadyState(false, false);
        setError('Consent could not be saved. Please try again.');
      });
  }

  function clearConsent() {
    const body = JSON.stringify({
      attributes: {
        digital_access_waiver_accepted: 'false',
        digital_access_waiver_accepted_at: '',
        digital_access_waiver_source: 'cart_page',
        digital_access_waiver_version: ''
      }
    });

    setReadyState(false, true);
    setError('');

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(() => {
        setReadyState(false, false);
      })
      .catch(() => {
        setReadyState(false, false);
      });
  }

  function handleChange(event) {
    if (!event.target.matches(selectors.checkbox)) return;

    if (!event.target.checked) {
      clearConsent();
      return;
    }

    saveConsent();
  }

  function handleSubmit(event) {
    if (!event.target.matches(selectors.form)) return;
    if (event.submitter && event.submitter.name && event.submitter.name !== 'checkout') return;
    if (consentReady && !consentSavePending) return;

    event.preventDefault();

    if (!consentSavePending) {
      showConsentError();
    }
  }

  function init() {
    const { checkbox } = getElements();

    consentReady = Boolean(checkbox && checkbox.checked);
    consentSavePending = false;

    setCheckoutState(consentReady, false);
    setupExpressOverlays();

    document.addEventListener('change', handleChange);
    document.addEventListener('submit', handleSubmit);

    const observer = new MutationObserver(setupExpressOverlays);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
